import TrainingRegistrationCourseCallout from './TrainingRegistrationCourseCallout.vue';

export default TrainingRegistrationCourseCallout;
